module.exports = [{"name":"sidebar.applications","icon":"fas fa-cloud","activeClass":"","submenus":[{"name":"sidebar.all","router":{"name":"AppsCategoryAll"},"activeClass":""},{"name":"sidebar.boostsales","router":{"name":"AppsCategoryBoostSales"},"activeClass":""},{"name":"sidebar.operations","router":{"name":"AppsCategoryOparations"},"activeClass":""},{"name":"sidebar.accountingfinance","router":{"name":"AppsCategoryAccountingFinance"},"activeClass":""},{"name":"sidebar.otherapp","router":{"name":"AppsCategoryOther"},"activeClass":""}]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/apps/applications/sidebar.json
// module id = GfUA
// module chunks = 1